/**
 * @name TableFilter.js
 * @author Fellipe Orsini
 * @package clinic-mvp\app\assets\js\TableFilter.js
 */


var getBaseDir = null, apiCall = null;

$(function()
{
    import('../../utils.js').then(utils => {
        getBaseDir = utils.getBaseDir;
        apiCall = utils.apiCall;

        if (!utils.isUserLoggedIn())
            return;

        new TableFilter(true, {
            getBaseDir: utils.getBaseDir,
            apiCall: utils.apiCall,
        });
    });
});

class TableFilter
{
    constructor(onloadList=false, deps = {})
    {
        this.deps = deps;
        this.bindDOMVisualFilter();
    }

    bindDOMVisualFilter() {
        $(document).on('click', '.filter-show-button', function(e) {
            e.preventDefault();

            let isClosed = $('.filter-container').hasClass('d-none');
            if (isClosed) {
                $(this).html(`<span class="pe-7s-filter"></span> Esconder filtros`);
                $('.filter-container').removeClass('d-none');
                $('.filter-container').addClass('d-block');
            } else {
                $(this).html(`<span class="pe-7s-filter"></span> Mostrar filtros`);
                $('.filter-container').removeClass('d-block');
                $('.filter-container').addClass('d-none');
            }
        });
    }
}